import { bindMethod } from 'helpers/bind';
import { clamp } from 'lodash-es';
import Component from 'navigation/component/Component';
export default class SizeGuideTable extends Component {
    track;
    width;
    delta = 0;
    mouse = {
        x: 0,
        prevX: 0,
        startTime: null
    };
    _grabbing = false;
    _moving = false;
    _scrollable = false;
    get scrollable() {
        return this._scrollable;
    }
    set scrollable(value) {
        this._scrollable = value;
        this.track.parentElement.classList.toggle('scrollable', value);
    }
    get grabbing() {
        return this._grabbing;
    }
    set grabbing(value) {
        this._grabbing = value;
        if (value) {
            document.body.style.cursor = 'grabbing';
            this.track.classList.add('grabbing');
        }
        else {
            document.body.style.cursor = 'default';
            this.track.classList.remove('grabbing');
        }
    }
    get moving() {
        return this._moving;
    }
    set moving(value) {
        this._moving = value;
        if (value) {
            this.el.classList.add('moving');
        }
        else {
            this.el.classList.remove('moving');
            this._grabbing = false;
            this._moving = false;
        }
    }
    buildScrollbar = () => {
        if (this.el.scrollWidth < this.el.clientWidth)
            return;
        const wrapper = document.createElement('div');
        wrapper.classList.add('sizes__scrollbar');
        this.track = document.createElement('button');
        this.track.setAttribute('type', 'button');
        this.track.classList.add('sizes__track');
        this.track.style.width = this.el.clientWidth / this.el.scrollWidth * 100 + '%';
        this.width = this.el.clientWidth / this.el.scrollWidth * 100;
        wrapper.appendChild(this.track);
        this.el.after(wrapper);
        this.checkScrollable();
    };
    initialized() {
        this.buildScrollbar();
        super.initialized();
    }
    bindEvents(add) {
        const method = bindMethod(add);
        this.track[method]('mousedown', this.onTrackMouseDown);
        window[method]('mousemove', this.onTrackMouseMove);
        window[method]('mouseup', this.onTrackMouseUp);
        this.track[method]('touchstart', this.onTouchStart);
        window[method]('touchmove', this.onTouchMove);
        window[method]('touchend', this.onTouchEnd);
        this.el[method]('touchstart', this.onTouchStart);
        this.el[method]('wheel', this.onWheel);
    }
    checkScrollable = () => {
        this.scrollable = this.el.scrollWidth > this.el.clientWidth;
    };
    onWheel = (e) => {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.move(e.deltaX);
    };
    onScroll = () => {
        this.width = this.el.clientWidth / this.el.scrollWidth * 100;
        const progress = this.el.scrollLeft / (this.el.scrollWidth - this.el.clientWidth);
        this.track.style.left = `${progress * (100 - this.width)}%`;
    };
    onTouchStart = (e) => {
        this.mouse = {
            x: e.touches[0].clientX,
            prevX: e.touches[0].clientX,
            startTime: Date.now()
        };
        this.grabbing = true;
    };
    onTouchMove = (e) => {
        if (this.grabbing) {
            if (!this.moving)
                this.moving = true;
            const target = e.target;
            let direction = -1;
            if (target.classList.contains('sizes__track'))
                direction = 1;
            const delta = e.touches[0].clientX - this.mouse.x;
            this.move(delta * direction);
            this.mouse.prevX = this.mouse.x;
            this.mouse.x = e.touches[0].clientX;
        }
    };
    onTouchEnd = (e) => {
        this.grabbing = false;
        this.moving = false;
    };
    onTrackMouseDown = (e) => {
        this.mouse = {
            x: e.clientX,
            prevX: e.clientX,
            startTime: Date.now()
        };
        this.grabbing = true;
    };
    onTrackMouseMove = (e) => {
        if (this.grabbing) {
            if (!this.moving)
                this.moving = true;
            const delta = e.clientX - this.mouse.x;
            this.move(delta);
            this.mouse.prevX = this.mouse.x;
            this.mouse.x = e.clientX;
        }
    };
    onTrackMouseUp = (e) => {
        if (this.mouse.startTime) {
            if (this.mouse.startTime + 100 < Date.now())
                e.preventDefault();
            this.grabbing = false;
            this.moving = false;
        }
    };
    move = (delta) => {
        const w = this.el.scrollWidth - this.el.clientWidth;
        this.delta = clamp(this.delta - delta, -w, 0);
        this.el.scrollTo({ left: -this.delta });
        this.track.style.left = `${-this.delta / w * (100 - this.width)}%`;
    };
    resize() {
        this.checkScrollable();
        this.track.style.width = this.el.clientWidth / this.el.scrollWidth * 100 + '%';
        this.onScroll();
        super.resize();
    }
}
